<template>
  <div class="consent-page-first-div">
      <div class="consent-page">
          <p class="text-top" v-html="$t('consent_page:give_student_discounts')"></p>
          <p class="text-second" v-html="$t('consent_page:info_text')"></p>
          <div class="policy-link" ref="policyel">
            <router-link to="/terms">{{ $t("consent_page:process_info") }}</router-link>
        </div>
        </div>
        <button class="button-consent-page first" v-html="$t('consent_page:button_yes')"></button>
        <button class="button-consent-page" v-html="$t('consent_page:button_no')"></button>
  </div>
</template>
<i18n>
{
  "sv": {
    "consent_page:give_student_discounts":"Vi vill skicka dig intressanta studentrabatter.",
    "consent_page:info_text":"Godkänner du att vi ger dig relevanta & mer anpassade studenterbjudanden, via e-post & push-notiser, baserat på dina tidigare köp- och surfvanor hos oss?",
    "consent_page:process_info":"Så behandlar vi dina personuppgifter",
    "consent_page:button_yes":"Ok!",
    "consent_page:button_no":"Nej tack"
  },
  "en": {
    "consent_page:give_student_discounts":"We want to send you interesting student discounts.",
    "consent_page:info_text":"Do you agree that we give you relevant and more customized student offers, by email and push notifications, based on your previous purchase and browsing habits at Mecenat?",
    "consent_page:process_info":"Read more about how we process your personal information.",
    "consent_page:button_yes":"Yes",
    "consent_page:button_no":"No, thanks"
  }
}
</i18n>
<script>
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    components: {

    }
})

export default class ConsentPage extends Vue {

}
</script>

<style lang="scss" scoped>
.consent-page-first-div {

    @media (min-width: 768px) {
        margin-top: 80px;
    }


.consent-page {

    @media (max-width: 768px) {
        background: #F3F0ED;
        border-radius: 24px 24px 24px 0px;
        min-height: 125px;
        width: 324px;
        margin: auto;
    }

    @media (max-width: 360px) {
        width: 90%;
    }


    .text-top {
        font-family: Roboto Condensed;
        font-weight: 600;
        font-size: 18px;
        line-height: 28px;
        text-align: center;
        padding-top: 30px;
        padding-bottom: 0px;
        width: 90%;
        margin: auto;
    }

    .text-second {
        font-family: Roboto Condensed;
        font-size: 16px;
        line-height: 135%;
        width: 90%;
        margin: auto;
        text-align: center;
        padding-top: 25px;
    }

    .policy-link {
        margin: auto;
        display: table;
        margin-bottom: 20px;
        font-weight: 500;
        font-size: 16px;
        font-family: Roboto;
        cursor: pointer;
        text-align: center;
        padding: 30px 0px;
        width: 90%;
    }
}

    .button-consent-page {
        background: linear-gradient(180deg, #EAEAEA 0%, #CFCFCF 100%);
        border-radius: 8px;
        width: 220px;
        height: 40px;
        display: block;
        text-align: center;
        margin: auto;
        margin-bottom: 15px;
        color: #10a5c5;
        font-size: 16px;
        font-weight: 600;
        font-family: Roboto Condensed;

        @media (min-width: 500px) and (max-width: 768px) {
            display: unset;
            width: 120px;
            float: right;
            margin-right: 25px;
        }

        &.first {
            @media (min-width: 500px) and (max-width: 768px) {
            float: left;
            margin-left: 25px;
            }
        }
    }
}

</style>